import { type Static, Type } from "@sinclair/typebox"
import { UserinfoResponseSchema } from "./auth"
import { JsonRecordSchema } from "./common"

// Perfil propio — docs/04 §2 (`/v1/me`).

// GET /v1/me = userinfo + atributos custom `profile`.
export const MeResponseSchema = Type.Composite([
  UserinfoResponseSchema,
  Type.Object({ profile: JsonRecordSchema }),
])
export type MeResponse = Static<typeof MeResponseSchema>

// PATCH /v1/me — username NO es editable self-service; el cambio de email dispara
// confirmación al nuevo email [V1].
export const UpdateMeRequestSchema = Type.Object({
  name: Type.Optional(Type.String({ maxLength: 200 })),
  email: Type.Optional(Type.String({ format: "email" })),
  profile: Type.Optional(JsonRecordSchema),
})
export type UpdateMeRequest = Static<typeof UpdateMeRequestSchema>

// POST /v1/me/password — exige la contraseña actual; por defecto revoca las demás
// familias de sesión (configurable).
export const ChangePasswordRequestSchema = Type.Object({
  current_password: Type.String({ minLength: 1 }),
  new_password: Type.String({ minLength: 1 }),
})
export type ChangePasswordRequest = Static<typeof ChangePasswordRequestSchema>

export const ChangePasswordResponseSchema = Type.Object({
  ok: Type.Literal(true),
  // Familias de sesión revocadas por el cambio
  revoked_sessions: Type.Integer(),
})
export type ChangePasswordResponse = Static<typeof ChangePasswordResponseSchema>
